export const accountId = "5522450834001"
export const playerId = "GmUsBqClI"
export const playerEmbed = "default"
